module.exports = __webpack_public_path__ + "static/img/dev_logo.4941eb86.png";